import { render, staticRenderFns } from "./Kompetenzraster.vue?vue&type=template&id=5ff85ffd&"
import script from "./Kompetenzraster.vue?vue&type=script&lang=js&"
export * from "./Kompetenzraster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports